<template>
    <div class="block">
        <slot></slot>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Block extends Vue {
    name = 'block';
}

Vue.component('block', Block);
</script>
